import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	margin: 1% 0 0 0;
	padding: 0 2%;
`;

export const FilterWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
  	justify-content: space-evenly;
  	margin:20px;
  > div {
		> div {
			> div {
        border-radius: 0;
      }
		}
  .ap-button-main {
    height: 32px;
  }
`;
export const SingleFilterWrapper = styled.div`
	padding: 5px;
`;
export const ButtonWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

export const TableWrapper = styled.div`
	width: 100%;
	overflow: hidden;

	.ag-theme-balham {
		width: 100%;
		height: 100%;
		font-family: 'Roboto';

		.ag-root-wrapper {
			border-bottom: 1px solid ${colors.grey3};
		}

		.ag-header {
			background-color: transparent;
			color: ${colors.grey5};
		}

		.ag-header-cell {
			font-weight: normal;
			font-size: 11px;
			line-height: 13px;
			letter-spacing: 0.8px;
			padding-bottom: 5px;
			font-family: 'Roboto';

			.ag-header-cell-text {
				white-space: pre-line;
			}

			&.ag-numeric-header {
				text-align: right;
			}

			&::after {
				display: none;
			}
		}

		.ag-row {
			background-color: transparent;
			border-color: ${colors.grey3};

			&.ag-row-last {
				border-bottom: none;
			}

			.ag-cell {
				font-size: 13px;
				font-weight: normal;
				line-height: 24px;
				letter-spacing: 0.3px;
				color: ${colors.grey5};
			}
		}

		.ag-floating-top-viewport {
			border: none;
		}

		.ag-floating-top {
			border-color: ${colors.grey3};
		}

		.ag-row-pinned {
			border: none;

			&.ag-row-last {
				border: none;
			}

			.ag-cell {
				font-weight: bold;
			}
		}

		.ag-header-row-column {
			border-bottom: 1px solid ${colors.grey3};
		}
	}
`;
export const ValueWrapper = styled.div`
	display: inline-flex;
	box-sizing: content-box;
	width: 60px;
	margin-bottom: 19px;
`;
export const SummaryValue = styled.td`
	color: ${colors.black};
	font-size: 16px;
	font-weight: 500;
	line-height: 32px;
	display: flex;
	align-items: flex-start;
	padding: 8px 0;
	height: 56px;
`;

export const Container = styled.div`
	display: flex;
`;
